import { ENDPOINT } from "../utils/constants";
import { request } from "../utils/request";

export const getExamResultsByUserEmail = async (email) => {
	const data = await request({
		url: `${ENDPOINT.EXAM_RESULTS}?fields=date,emailAddress,firstName,id,lastName,testName,result&filter=emailAddress eq '${email}' and result eq 'pass'&pageSize=0`,
		method: "get",
	});
	return data.items
}